module.exports = __webpack_public_path__ + "img/load.1e94875e.png";